import { render, staticRenderFns } from "./MobileOrder.vue?vue&type=template&id=4e474c12&scoped=true&lang=pug&"
import script from "./MobileOrder.vue?vue&type=script&lang=js&"
export * from "./MobileOrder.vue?vue&type=script&lang=js&"
import style0 from "./MobileOrder.vue?vue&type=style&index=0&id=4e474c12&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e474c12",
  null
  
)

export default component.exports